module.exports = __webpack_public_path__ + "img/google_play@3x.65ca3447.png";